import type { GameManifest } from "../../contracts/game";
import { configuredFreecivOrigin } from "./runtime";

const enabled = import.meta.env.VITE_FREECIV_ENABLED === "true" && configuredFreecivOrigin() !== null;

export const freecivManifest: GameManifest = {
  id: "freeciv",
  title: "Freeciv",
  version: "0.1.0",
  status: enabled ? "playable" : "hidden",
  coverAsset: "/covers/freeciv.svg",
  catalogOrder: 7,
  preferredAspectRatio: 16 / 10,
  supportsCpu: true,
  offline: "online-only",
  load: () => import("./index"),
};
